import { formatDisplayDate } from "../../../utils/dateDisplay";
import { parseBritishDate } from "../../../utils/insightDates";

export function formatRaidInsightDueDate(dueDate?: string | null): string {
  return formatDisplayDate(dueDate, { fallback: "Not available", timeZone: "UTC" });
}

export function formatRaidInsightDaysLeft(
  dueDate?: string | null,
  asAtDate?: string | null
): string {
  if (
    dueDate == null ||
    asAtDate == null ||
    dueDate.trim().length === 0 ||
    asAtDate.trim().length === 0
  ) {
    return "Not available";
  }

  // Insight dates arrive as DD-MM-YYYY; ISO is still accepted for stored data.
  const due = parseBritishDate(dueDate) ?? new Date(dueDate);
  const asAt = parseBritishDate(asAtDate) ?? new Date(asAtDate);
  if (Number.isNaN(due.getTime()) || Number.isNaN(asAt.getTime())) {
    return "Not available";
  }

  const utcDate = (date: Date) =>
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  const days = Math.floor((utcDate(due) - utcDate(asAt)) / (24 * 60 * 60 * 1000));
  return days < 0 ? `Overdue by ${Math.abs(days)}d` : `${days}d left`;
}
